export enum UpdateFacilityField {
  Company = "company",
  CompanyName = "company_id",
  Area = "area",
  FacilityName = "facility_name",
  FacilityNameInArabic = "facility_name_in_arabic",
  OpeningHours = "opening_hours",
  Geolocation = "geolocation",
  Image = "image",
  Payment = "payment",
  Rank = "rank",
  FixedBooking = "",
  splitpayment = "is_split_payment",
  is_fixed_booking = "is_fixed_booking",
}

export type UpdateFacilityFormValues = {
  [UpdateFacilityField.CompanyName]: string;
  [UpdateFacilityField.Area]: string;
  [UpdateFacilityField.FacilityName]: string;
  [UpdateFacilityField.FacilityNameInArabic]: string;
  [UpdateFacilityField.Rank]: number;
  [UpdateFacilityField.OpeningHours]: [string, string];
  [UpdateFacilityField.Geolocation]: string;
  [UpdateFacilityField.Image]: unknown;
  [UpdateFacilityField.Payment]: string[];
  [UpdateFacilityField.splitpayment]: boolean;
  [UpdateFacilityField.is_fixed_booking]: boolean;
};
